<template>
  <div v-if="!returnSecondSection">
    <form @submit.prevent="onSubmit">
      <h3>
        1. Da li ste osoba s invaliditetom i/ili član/ica porodice osobe s
        invaliditetom?
      </h3>

      <div class="checkbox-label">
        <RadioButton
          name="isOsiOrFamily"
          value="yes"
          inputId="isOsiOrFamily-yes"
          v-model="selectedRadioChoice"
        />
        <label for="isOsiOrFamily-yes" class="label">Da</label>
        <RadioButton
          name="isOsiOrFamily"
          value="no"
          inputId="isOsiOrFamily-no"
          v-model="selectedRadioChoice"
        />
        <label for="isOsiOrFamily-no" class="label">Ne</label>
      </div>
      <div v-if="selectedRadioChoice === 'yes'">
        <p style="color: red">
          Za popunjavanje Prijave za učlanjenje u I MI Boke će Vam trebati 30
          min do 2 sata. Prijavu morate popuniti odjednom. Ako Vam je naporno da
          sve popunite možete ostaviti samo ime i prezime, adresu i broj
          mobilnog telefona, te kliktati dugme „Nastavi” sve dok ne dođete do
          kraja Prijave i ne kliknete dugme „Pošalji odgovor”. Po prijemu
          nepotpune Prijave, mi ćemo Vas kontaktirati i dogovoriti se za termin
          i način pružanja podrške za popunjavanje nedostajućih podataka.
        </p>
        <h3>
          2. Da li ste Vi osoba s invaliditetom koja želi da postane član/ica I
          MI Boke?
        </h3>
        <div class="rbutton">
          <RadioButton
            name="whoFillsForm"
            value="firstOption"
            inputId="firstOption"
            v-model="invalidPerson"
            class="checkbox-label2"
            style="margin-right: 10px; margin-top: 15px"
          />
          <label for="firstOption" style="margin-top: 15px"
            >Ja imam invaliditet i želim da postanem član/ica I MI Boke</label
          >
        </div>
        <div class="rbutton">
          <RadioButton
            name="whoFillsForm"
            value="secondOption"
            inputId="secondOption"
            v-model="invalidPerson"
            class="checkbox-label2"
            style="margin-right: 10px; margin-top: 15px"
          />
          <label for="secondOption" style="margin-top: 15px"
            >Ja dajem odgovore umjesto osobe s invaliditetom koja želi da
            postane član/ica I MI Boke</label
          >
        </div>
        <div v-if="invalidPerson === 'firstOption'">
          <h4>3. Ime i prezime osobe s invaliditetom</h4>
          <InputText
            type="text"
            v-model="value"
            placeholder="Unesite ime i prezime"
            name="firstAndLastName"
          />

          <h4>4. Pol</h4>
          <Dropdown
            v-model="selectedGender"
            :options="genders"
            placeholder="Izaberite"
            class="dropdown"
          />

          <h4>5. Datum rođenja</h4>
          <Calendar
            v-model="dateOfBirthModel"
            showIcon
            :dateFormat="dateFormat"
            placeholder="dd/mm/yyyy"
            class="calendar"
            name="dateOfBirth"
            :manualInput="false"
            showButtonBar
            :yearNavigator="true"
            :yearRange="`1930:${new Date().getFullYear()}`"
            :maxDate="new Date()"
          />

          <h4>6. Mjesto rođenja</h4>
          <LocationSelect
            v-model:country="countryPlaceOfBirth"
            v-model:city="cityPlaceOfBirth"
            countryPlaceholder="Država"
            cityPlaceholder="Grad"
          />

          <h4>7. Adresa prebivališta/boravišta u Crnoj Gori</h4>
          <InputText
            type="text"
            placeholder="Ulica i broj"
            class="inline-input"
            v-model="ulicaIBroj"
            name="streetAndNumber"
          />
          <InputText
            type="text"
            placeholder="Poštanski fah"
            class="inline-input"
            name="postCode"
            v-model="postCode"
          />
          <LocationSelect
            v-model:city="city"
            :showCountry="false"
            cityPlaceholder="Grad"
          />

          <h4>Tip naselja</h4>
          <Dropdown
            v-model="selectTypeOfSettlement"
            :options="settlements"
            placeholder="Izaberite"
            class="dropdown"
          />

          <h4>8. Kontakt podaci osobe s invaliditetom</h4>
          <PhoneInput v-model="mobilePhone" placeholder="Broj mobilnog telefona" class="inline-input" />
          <InputText
            type="text"
            placeholder="E-mail adresa"
            class="inline-input"
            name="email"
            v-model="email"
          />
          <PhoneInput v-model="viber" placeholder="Viber" class="inline-input" />
          <PhoneInput v-model="homePhoneNumber" placeholder="Broj fiksnog telefona" class="inline-input" />
          <PhoneInput v-model="whatsapp" placeholder="WhatsApp" class="inline-input" />
          <PhoneInput v-model="signal" placeholder="Signal" class="inline-input" />
          <PhoneInput v-model="telegram" placeholder="Telegram" class="inline-input" />

          <InputText
            type="text"
            placeholder="Facebook Messenger"
            class="inline-input"
            name="facebook"
            v-model="facebook"
          />

          <h4>9. Školska sprema</h4>
          <Dropdown
            v-model="educationalBackground"
            :options="educational"
            placeholder="Izaberite"
            class="dropdown"
            name="educationBackground"
          />

          <h4>10. Zanimanje</h4>
          <InputText
            type="text"
            placeholder="Unesite Vaše zanimanje"
            name="profession"
            v-model="profession"
          />

          <h4>11. Radni status</h4>
          <Dropdown
            v-model="selectedWorkStatus"
            :options="status"
            placeholder="Izaberite"
            class="dropdown"
          />

          <h4>12. Vrsta invaliditeta</h4>
          <!-- <Dropdown
            v-model="typeOfDisability"
            :options="disabilities"
            placeholder="Izaberite"
            class="dropdown"
            name="typeOfInvalidity"
          /> -->
          <div class="relative">
            <MultiSelect
              v-model="typeOfDisability"
              :options="disabilities"
              optionLabel="period"
              placeholder="Izaberite"
              :maxSelectedLabels="20"
              class="w-full md:w-20rem"
              name="typeOfInvalidity"
            />
          </div>
          <div class="button-container">
            <Button type="submit" class="sendAnswers"
              >Nastavi</Button
            >
          </div>
        </div>
        <div v-if="invalidPerson === 'secondOption'">
          <h4>Ime i prezime kontakt osobe za osobu s invaliditetom</h4>
          <InputText
            type="text"
            placeholder="Unesite ime i prezime"
            name="firstNameAndSurname"
            v-model="contactPersonName"
          />

          <h4>Srodstvo/odnos s osobom s invaliditetom</h4>
          <Dropdown
            v-model="typeOfKinship"
            :options="kinships"
            placeholder="Izaberite"
            class="dropdown"
          />
          <h4>Kontakt podaci kontakt osobe</h4>
          <PhoneInput v-model="contactPersonPhone" placeholder="Broj mobilnog telefona" class="inline-input" />
          <InputText
            type="text"
            placeholder="E-mail adresa"
            class="inline-input"
            name="contactPersonEmail"
            v-model="contactPersonEmail"
          />
          <PhoneInput v-model="contactPersonViber" placeholder="Viber" class="inline-input" />
          <h4>3. Ime i prezime osobe s invaliditetom</h4>
          <InputText
            type="text"
            placeholder="Unesite ime i prezime"
            name="firstAndLastName"
            v-model="value"
          />

          <h4>4. Pol</h4>
          <Dropdown
            v-model="selectedGender"
            :options="genders"
            placeholder="Izaberite"
            class="dropdown"
          />

          <h4>5. Datum rođenja</h4>
          <Calendar
            v-model="dateOfBirthModel"
            showIcon
            :dateFormat="dateFormat"
            placeholder="dd/mm/yyyy"
            class="calendar"
            name="dateOfBirth"
            :manualInput="false"
            showButtonBar
            :yearNavigator="true"
            :yearRange="`1930:${new Date().getFullYear()}`"
            :maxDate="new Date()"
          />

          <h4>6. Mjesto rođenja</h4>
          <LocationSelect
            v-model:country="countryPlaceOfBirth"
            v-model:city="cityPlaceOfBirth"
            countryPlaceholder="Država"
            cityPlaceholder="Grad"
          />

          <h4>7. Adresa prebivališta/boravišta u Crnoj Gori</h4>
          <InputText
            type="text"
            placeholder="Ulica i broj"
            class="inline-input"
            v-model="ulicaIBroj"
            name="streetAndNumber"
          />
          <InputText
            type="text"
            placeholder="Poštanski fah"
            class="inline-input"
            name="postCode"
            v-model="postCode"
          />
          <LocationSelect
            v-model:city="city"
            :showCountry="false"
            cityPlaceholder="Grad"
          />

          <h4>Tip naselja</h4>
          <Dropdown
            v-model="selectTypeOfSettlement"
            :options="settlements"
            placeholder="Izaberite"
            class="dropdown"
          />

          <h4>8. Kontakt podaci osobe s invaliditetom</h4>
          <PhoneInput v-model="mobilePhone" placeholder="Broj mobilnog telefona" class="inline-input" />
          <InputText
            type="text"
            placeholder="E-mail adresa"
            class="inline-input"
            name="email"
            v-model="email"
          />
          <PhoneInput v-model="viber" placeholder="Viber" class="inline-input" />
          <PhoneInput v-model="homePhoneNumber" placeholder="Broj fiksnog telefona" class="inline-input" />
          <PhoneInput v-model="whatsapp" placeholder="WhatsApp" class="inline-input" />
          <PhoneInput v-model="signal" placeholder="Signal" class="inline-input" />
          <PhoneInput v-model="telegram" placeholder="Telegram" class="inline-input" />

          <InputText
            type="text"
            placeholder="Facebook Messenger"
            class="inline-input"
            name="facebook"
            v-model="facebook"
          />

          <h4>9. Školska sprema</h4>
          <Dropdown
            v-model="educationalBackground"
            :options="educational"
            placeholder="Izaberite"
            class="dropdown"
          />

          <h4>10. Zanimanje</h4>
          <InputText
            type="text"
            placeholder="Unesite Vaše zanimanje"
            name="profession"
            v-model="profession"
          />

          <h4>11. Radni status</h4>
          <Dropdown
            v-model="selectedWorkStatus"
            :options="status"
            placeholder="Izaberite"
            class="dropdown"
          />

          <h4>12. Vrsta invaliditeta</h4>
          <!-- <Dropdown
            v-model="typeOfDisability"
            :options="disabilities"
            placeholder="Izaberite"
            class="dropdown"
          /> -->
          <div class="relative">
            <MultiSelect
              v-model="typeOfDisability"
              :options="disabilities"
              optionLabel="period"
              placeholder="Izaberite"
              :maxSelectedLabels="20"
              class="w-full md:w-20rem"
              name="typeOfInvalidity"
            />
          </div>

          <div class="button-container">
            <Button type="submit" class="sendAnswers"
              >Nastavi</Button
            >
          </div>
        </div>
      </div>
    </form>
  </div>
  <SecondSection v-if="returnSecondSection" />
</template>

<script setup>
import { inject, ref, nextTick, computed, provide } from "vue";
import SecondSection from "./SecondSection.vue";
import PhoneInput from "./PhoneInput.vue";
import LocationSelect from "./LocationSelect.vue";

// Dohvatanje objekta iz providera
const objekat = inject("objekat");

// Definisanje listi opcija
const status = [
  "Angažovan/a bez ikakvog ugovora („na crno”)",
  "Angažovan/a po ugovoru o djelu",
  "Zaposlen/a na nepuno radno vrijeme",
  "Zaposlen/a na puno radno vrijeme, na određeno",
  "Zaposlen/a na puno radno vrijeme, na neodređeno",
  "Nezaposlen/a",
  "Na školovanju",
  "Dijete mlađe od školskog uzrasta",
  "Penzioner/ka",
];
const genders = ["Muški", "Ženski", "Ne želim da kažem"];
const settlements = [
  "Predgrađe",
  "Ruralno područje (selo)",
  "Širi centar grada",
  "Uži centar grada",
];
const educational = [
  "Bez škole",
  "Osnovna škola",
  "Srednja škola III stepen",
  "Srednja škola IV stepen",
  "Viša škola",
  "Visoka škola",
  "Master",
  "Doktor nauka",
];
const disabilities = [
  {
    period:
      "Fizički invaliditet (motorički, otežano pomjeranje i/ili kretanje)",
  },
  { period: "Oštećenje vida" },
  { period: "Oštećenje sluha i/ili govora" },
  { period: "Intelektualni invaliditet (smanjen IQ)" },
  {
    period:
      "Psihosocijalni invaliditet (mentalni/psihički/duševni invaliditet, autizam i sl.)",
  },
];
const kinships = [
  "Majka",
  "Otac",
  "Brat",
  "Sestra",
  "Muž",
  "Žena",
  "Dijete",
  "Deda",
  "Baka",
  "Zet/snaha",
  "Rođak/a",
  "Komšija/inica",
  "Prijatelj/ica",
  "Druga osoba s invaliditetom",
  "Zaposleni/a u instituciji",
  "Staralac/teljka",
  "Advokat/ica",
];

// Vraća izbor iz MultiSelect-a mapiran na objekte iz liste opcija (poređenje po "period"),
// da bi prethodno sačuvane vrijednosti bile prikazane kao izabrane.
function restoreSelection(options, saved) {
  if (!Array.isArray(saved)) return saved ?? null;
  return saved
    .map((item) => {
      const period = item && typeof item === "object" ? item.period : item;
      return options.find((o) => o.period === period) || (period ? { period } : null);
    })
    .filter(Boolean);
}

const clean = (v) => (typeof v === "string" ? v.trim() : v);
const isBlank = (v) => !v || String(v).trim() === "";

// Ref-ovi za podatke i stanja (inicijalizovani iz objekta, da se ništa ne izgubi)
const ci = objekat.contactInformation;
const cp = objekat.contactPerson;

const selectedRadioChoice = ref(null);
const invalidPerson = ref(null);

const value = ref(objekat.firstAndLastName || "");
const selectedGender = ref(objekat.gender);
const dateFormat = "dd/mm/yy";
const cityPlaceOfBirth = ref(objekat.placeOfBirth.cityPlaceOfBirth || "");
const countryPlaceOfBirth = ref(objekat.placeOfBirth.countryPlaceOfBirth || "");
const ulicaIBroj = ref(objekat.addressInfo.streetAndNumber || "");
const postCode = ref(objekat.addressInfo.postCode || "");
const city = ref(objekat.addressInfo.city || "");
const selectTypeOfSettlement = ref(objekat.addressInfo.typeOfSettlement);

// Kontakt podaci osobe s invaliditetom (oba slučaja)
const mobilePhone = ref(ci.mobilePhone || "");
const email = ref(ci.email || "");
const viber = ref(ci.viber || "");
const homePhoneNumber = ref(ci.homePhoneNumber || "");
const whatsapp = ref(ci.whatsapp || "");
const signal = ref(ci.signal || "");
const telegram = ref(ci.telegram || "");
const facebook = ref(ci.facebook || "");

const educationalBackground = ref(objekat.educationBackground);
const profession = ref(objekat.profession || "");
const selectedWorkStatus = ref(objekat.workStatus);
const typeOfDisability = ref(restoreSelection(disabilities, objekat.typeOfInvalidity));

// Kontakt osoba (samo kad neko drugi popunjava prijavu - "secondOption")
const contactPersonName = ref(cp.firstNameAndSurname || "");
const typeOfKinship = ref(cp.kinship);
const contactPersonPhone = ref(cp.contactPersonPhoneNumber || "");
const contactPersonEmail = ref(cp.contactPersonEmail || "");
const contactPersonViber = ref(cp.contactPersonViber || "");

function parseDateFull(str) {
  if (!str) return null;
  const [day, month, year] = str.split("/");
  return new Date(Number(year), Number(month) - 1, Number(day));
}

// Formatira JS Date u "dd/mm/yyyy"
function formatDateFull(datum) {
  if (!datum) return "";
  const d = new Date(datum);
  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear(); // cijela godina
  return `${day}/${month}/${year}`;
}

// computed v-model koji radi bidirekciju String ⇄ Date
const dateOfBirthModel = computed({
  get() {
    // Calendar prima JS Date
    return parseDateFull(objekat.dateOfBirth);
  },
  set(value) {
    // i uvijek u globalni objekt sprema puni string "dd/mm/yyyy"
    objekat.dateOfBirth = value ? formatDateFull(value) : null;
  },
});

const returnSecondSection = ref(false);
provide("returnSecondSection", returnSecondSection);

const pageContainer = inject("pageContainer");

// Validacija obaveznih polja; vraća true ako je sve u redu
const validate = () => {
  if (selectedRadioChoice.value !== "yes") {
    alert("Molimo Vas da odaberete 'yes' za izbor.");
    return false;
  }

  // Validacija - 3. Ime i prezime osobe s invaliditetom
  if (isBlank(value.value)) {
    alert("Molimo Vas da unesete ime i prezime osobe s invaliditetom.");
    return false;
  }

  // Validacija - 7. Adresa - Ulica i broj
  if (isBlank(ulicaIBroj.value)) {
    alert("Molimo Vas da unesete ulicu i broj.");
    return false;
  }

  // Validacija - 7. Adresa - Grad
  if (isBlank(city.value)) {
    alert("Molimo Vas da unesete grad.");
    return false;
  }

  // Validacija - broj mobilnog telefona:
  // - osoba popunjava za sebe: obavezan je njen broj (8. Kontakt podaci)
  // - neko drugi popunjava: obavezan je broj kontakt osobe
  if (invalidPerson.value === "firstOption") {
    if (isBlank(mobilePhone.value)) {
      alert("Molimo Vas da unesete broj mobilnog telefona.");
      return false;
    }
  } else if (isBlank(contactPersonPhone.value)) {
    alert("Molimo Vas da unesete broj mobilnog telefona kontakt osobe.");
    return false;
  }

  return true;
};

const saveToObjekat = () => {
  const forSelf = invalidPerson.value === "firstOption";

  objekat.firstAndLastName = clean(value.value);
  objekat.gender = selectedGender.value;
  const sel = dateOfBirthModel.value;
  objekat.dateOfBirth = sel ? formatDateFull(sel) : null;
  objekat.placeOfBirth.cityPlaceOfBirth = clean(cityPlaceOfBirth.value);
  objekat.placeOfBirth.countryPlaceOfBirth = countryPlaceOfBirth.value;
  objekat.addressInfo.streetAndNumber = clean(ulicaIBroj.value);
  objekat.addressInfo.postCode = clean(postCode.value);
  objekat.addressInfo.typeOfSettlement = selectTypeOfSettlement.value;
  objekat.addressInfo.city = clean(city.value);

  objekat.contactInformation.mobilePhone = mobilePhone.value;
  objekat.contactInformation.email = clean(email.value);
  objekat.contactInformation.viber = viber.value;
  objekat.contactInformation.homePhoneNumber = homePhoneNumber.value;
  objekat.contactInformation.whatsapp = whatsapp.value;
  objekat.contactInformation.signal = signal.value;
  objekat.contactInformation.telegram = telegram.value;
  objekat.contactInformation.facebook = clean(facebook.value);

  objekat.educationBackground = educationalBackground.value;
  objekat.profession = clean(profession.value);
  objekat.workStatus = selectedWorkStatus.value;
  objekat.typeOfInvalidity = typeOfDisability.value;

  // Kontakt osoba postoji samo kad neko drugi popunjava prijavu
  objekat.contactPerson.firstNameAndSurname = forSelf ? null : clean(contactPersonName.value);
  objekat.contactPerson.kinship = forSelf ? null : typeOfKinship.value;
  objekat.contactPerson.contactPersonPhoneNumber = forSelf ? null : contactPersonPhone.value;
  objekat.contactPerson.contactPersonEmail = forSelf ? null : clean(contactPersonEmail.value);
  objekat.contactPerson.contactPersonViber = forSelf ? null : contactPersonViber.value;
};

// Funkcija za obradu podataka prilikom slanja forme
const onSubmit = () => {
  if (!validate()) return;
  saveToObjekat();

  returnSecondSection.value = true;

  nextTick(() => {
    if (pageContainer.value) {
      // Ako je roditeljski element sa overflowom (npr. overflow-y: auto)
      pageContainer.value.scrollTop = 0;
    } else {
      // Rezervna opcija: skrolovanje celog prozora
      window.scrollTo({
        top: 0,
        behavior: "auto",
      });
    }
  });
};
</script>
